<div class="row">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-12 no-right-padding no-left-padding">
              <table formArrayName="packageForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>Package DI</th>
                    <th>Contains Package DI</th>
                    <th>Package Quantity</th>
                    <th *ngIf="dataScope.toLowerCase() !== dataScopeEnum.SKOREA.toLowerCase()" >Package Type</th>
                  </tr>
                  <tr formGroupName="{{i}}" *ngFor="let item of packageForm.controls; let i = index">
                    <td><label controlName="packageDi"></label></td>
                    <td><label controlName="containingDI"></label></td>
                    <td><label controlName="packageQty"></label>
                    </td>
                    <td *ngIf="dataScope.toLowerCase() !== dataScopeEnum.SKOREA.toLowerCase()"><label controlName="packageType"></label>
                    </td>
                  </tr>
                </tbody>
              </table>

            </td>
          </tr>


        </tbody>
      </table>
    </form>
  </div>
</div>
